import { Button, Dialog, DialogContent, DialogTitle, Slide, Snackbar } from '@material-ui/core';
import React, { useContext, useEffect, useRef, useState } from 'react'
import { AuthContext } from '../../../context/authContext';
import Http from '../../../Http';
import EspecialUline from './EspecialUline'
import EspecialUrrea from './EspecialUrrea'
import ACCESS from '../../../ACCESS';

export default function GuiasEspeciales() {
  const concorFileRef = useRef(null);
  const { hasAccess } = useContext(AuthContext);
  const [isLoading, setIsLoading] = useState(false);
  // const [concordFile, setConcordFile] = useState({ name: null });
  const flexiFileRef = useRef(null);
  const [SB, setSB] = useState({ open: false, msg: '' });

  // const ulineFileRef = useRef(null);
  const [ulineOpen, setUlineOpen] = useState(false);

  const urreaFileRef = useRef(null);
  const [urreaOpen, setUrreaOpen] = useState(false);

  const [actions, setActions] = useState({ concord: false, flexi: false, uline: false });

  useEffect(() => {
    actions.concord = hasAccess([ACCESS.GUIA.ARCHIVO_CONCORD]);
    actions.flexi = hasAccess([ACCESS.GUIA.ARCHIVO_FLEXI]);
    actions.uline = hasAccess([ACCESS.GUIA.ARCHIVO_ULINE]);
    actions.urrea = hasAccess([ACCESS.GUIA.ARCHIVO_URREA_VALVULAS]);
    // console.log(actions);
    setActions({ ...actions });

    // eslint-disable-next-line
  }, [])

  const concord_uploadFile = () => {
    concorFileRef.current.click();
  }

  const urrea_uploadFile = () => {
    urreaFileRef.current.click();
  }

  const concord_onFileUpload = async (e) => {
    let form = new FormData();
    form.append('type', 1);
    form.append('file', e.target.files[0]);
    try {
      setIsLoading(true);
      let res = await Http.post(`guia-especial/guias`, form);
      if (!res.error) {
        setSB({ open: true, msg: 'Guías subidas' });
      }
      else {
        setSB({ open: true, msg: `Error: ${res.errMsg}` });
      }
      concorFileRef.current.value = null;
    } catch (error) {
      setSB({ open: true, msg: `Error: No se pudo guardar` });
    }
    setIsLoading(false);
  }

  const urrea_onFileUpload = async (e) => {
    let form = new FormData();
    form.append('type', 7);
    form.append('file', e.target.files[0]);
    try {
      setIsLoading(true);
      let res = await Http.post(`guia-especial/guias`, form);
      if (!res.error) {
        setSB({ open: true, msg: 'Productos subidos' });
      }
      else {
        setSB({ open: true, msg: `Error: ${res.errMsg}` });
      }
      urreaFileRef.current.value = null;
    } catch (error) {
      console.log(error)
      setSB({ open: true, msg: `Error: No se pudo guardar` });
    }
    setIsLoading(false);
  }

  const flexi_uploadFile = () => {
    flexiFileRef.current.click();
  }

  const flexi_onFileUpload = async (e) => {
    let form = new FormData();
    form.append('type', 2);
    form.append('file', e.target.files[0]);
    try {
      setIsLoading(true);
      let res = await Http.post(`guia-especial/guias`, form);
      if (!res.error) {
        setSB({ open: true, msg: 'Guías subidas' });
      }
      else {
        let extra = null;
        if (res.data && Array.isArray(res.data))
          extra = res.data.toString();
        setSB({ open: true, msg: `Error: ${res.errMsg}${extra ? ` (${extra})` : ''}` });
      }
      flexiFileRef.current.value = null;
    } catch (error) {
      setSB({ open: true, msg: `Error: No se pudo guardar` });
    }
    setIsLoading(false);
  }
  const uline_upload = () => {
    setUlineOpen(true);
  }
  const urrea_upload = () => {
    setUrreaOpen(true);
  }

  return (
    <div>
      {actions.concord &&
        <div style={{ padding: 20 }}>
          <h2>Concord</h2>
          <Button disabled={isLoading} color='primary' variant='contained' onClick={concord_uploadFile}>Subir archivo (xls)</Button>
          <input type='file' hidden={true} ref={concorFileRef} onChange={concord_onFileUpload} />
        </div>
      }

      {actions.flexi &&
        <div style={{ padding: 20 }}>
          <h2>Flexi</h2>
          <Button disabled={isLoading} color='primary' variant='contained' onClick={flexi_uploadFile}>Subir archivo (txt)</Button>
          <input type='file' hidden={true} ref={flexiFileRef} onChange={flexi_onFileUpload} />
        </div>
      }

      {actions.uline &&
        <div style={{ padding: 20 }}>
          <h2>Uline</h2>
          <Button disabled={isLoading} color='primary' variant='contained' onClick={uline_upload}>Subir archivo (xlsx)</Button>
        </div>
      }

      {actions.urrea &&
        <div style={{ padding: 20 }}>
          <h2>Urrea Valvulas</h2>
          <div>
            <Button disabled={isLoading} color='primary' variant='contained' onClick={urrea_upload}>Carga de guias</Button>
          </div>
          <div>
            <Button disabled={isLoading} color='primary' variant='contained' onClick={urrea_uploadFile}>Carga de productos</Button>
            <input type='file' hidden={true} ref={urreaFileRef} onChange={urrea_onFileUpload} accept=".csv" />
          </div>
        </div>
      }

      <div>
        <Dialog
          maxWidth={'xl'}
          open={ulineOpen ? ulineOpen : false}
          onClose={() => { setUlineOpen(false) }}
        >
          <DialogTitle>
            Guias Uline
            </DialogTitle>
          <DialogContent>
            <EspecialUline />
            {/* <Salida id={dRow ? dRow.id : null}  onSave={this.guardadoLlegada} /> */}
          </DialogContent>
        </Dialog>
      </div>

      <div>
        <Dialog
          maxWidth={'xl'}
          open={urreaOpen ? urreaOpen : false}
          onClose={() => { setUrreaOpen(false) }}
        >
          <DialogTitle>
            Guias Urrea Valvulas
          </DialogTitle>
          <DialogContent>
            <EspecialUrrea />
          </DialogContent>
        </Dialog>
      </div>

      <Snackbar
        open={SB.open}
        onClose={() => { setSB({ open: false }) }}
        TransitionComponent={Slide}
        message={<span id="message-id">{SB.msg}</span>}
      />
    </div>
  )
}
